export function getBasename(pathname: string) {
  const segments = pathname.split('/').filter((segment) => segment !== '');
  const lastSegmentIndex = segments.findIndex((segment) =>
    segment.includes('.html'),
  );

  if (lastSegmentIndex === -1) {
    return pathname;
  }

  return `/${segments.slice(0, lastSegmentIndex + 1).join('/')}`;
}
